import { Language } from './language';

const it = {
    code: Language.it,

	// HOME PAGE

	t_description: 'Batterista ragazza, {age} anni',
	t_close: 'Vicino',

	b_home: 'Inizio',
	b_about: 'Su di me',
	b_press: 'Stampa e Media',
	b_shows: 'Spettacoli dal vivo',
	b_latest_show: 'Recente',
	b_soultone: 'Soultone',
	b_paiste: 'Paiste',
	b_collision: 'Collision',
	b_language: 'Italiano',
	b_share: 'Condividere',
	b_scroll_to_top: 'Vai all\'inizio',
	b_click: 'Clic',
	b_tap: 'Premere',

	t_english: 'Inglese',
	t_spanish: 'Spagnolo',
	t_portuguese: 'Portoghese',
	t_italian: 'Italiano',
	t_french: 'Francese',
	t_german: 'Tedesco',
	t_chinese: 'Cinese',

	// SHOWS PAGE

	KRKComeTogether2026DROM_title: 'Festival KRFK Come Together',
	KRKComeTogether2026DROM_description: 'DROM, New York City',

	KRKComeTogether2026Chelsea_title: 'Festival KRFK Come Together',
	KRKComeTogether2026Chelsea_description: 'Chelsea Table & Stage, New York City',

	RockFantasy2026Whisky_title: 'Campo Fantasy del Rock and Roll',
	RockFantasy2026Whisky_description: 'The Whisky a Go Go, Hollywood CA.',

	RockFantasy2026Viper_title: 'Campo Fantasy del Rock and Roll',
	RockFantasy2026Viper_description: 'The Viper Room, Hollywood CA.',

	FulcrumCelebrationOfLight2026_title: 'Celebrazione della Luce di Fulcrum',
	FulcrumCelebrationOfLight2026_description: 'Sheraton Grand Seattle',

	QueenTribute_title: 'Tributo ai Queen',
	QueenTribute_description: 'School of Rock Seattle',

	FremontFridays2025_title: 'Venerdì di Fremont 2025',
	FremontFridays2025_description: 'Venerdì di Fremont a Seattle',

	DrumFantasyCamp2025_title: 'Camp Drum Fantasy 2025',
	DrumFantasyCamp2025_description: 'Camp Drum Fantasy a Los Angeles',

	ClassicMetal_title: 'Metallo classico',
	ClassicMetal_description: 'School of Rock Seattle',

	StAlsGrandDay2024_title: 'Presentazione della Festa dei Nonni 2024',
	StAlsGrandDay2024_description: 'Scuola Sant\'Alfonso di Seattle',

	BlackViolinConcert_title: 'Concerto di violino nero con The World Your Orchestra',
	BlackViolinConcert_description: 'Il Teatro Paramount',

	MexicanIndependenceDay2024_title: 'Celebrazione dell\'Indipendenza del Messico con l\'Orchestra Civica Ballard',
	MexicanIndependenceDay2024_description: 'Municipio di Seattle',

	BluesRock_title: 'Blues Rock',
	BluesRock_description: 'School of Rock Seattle',

	BallardSeaFoodFest2024_title: 'Festival dei frutti di mare Ballard 2024',
	BallardSeaFoodFest2024_description: 'Festival dei frutti di mare Ballard',

	Funk_title: 'Funk',
	Funk_description: 'School of Rock Seattle',

	Heart_title: 'Heart',
	Heart_description: 'School of Rock Seattle',
	
	ModernMetal_title: 'Metallo moderno',
	ModernMetal_description: 'School of Rock Seattle',

	SeasonPreviewWinter2023_title: 'Anteprima stagione inverno 2023',
	SeasonPreviewWinter2023_description: 'School of Rock Seattle',

	SmashingPumpkins_title: 'Smashing Pumpkins',
	SmashingPumpkins_description: 'School of Rock Seattle',

	Nirvana_title: 'Nirvana',
	Nirvana_description: 'School of Rock Seattle',

	HairMetal_title: 'Metallo per capelli',
	HairMetal_description: 'School of Rock Seattle',

	TalentShow2023_title: 'Talent Show 2023',
	TalentShow2023_description: 'Seattle Salmon Bay K-8',

	Deftones_title: 'Deftones',
	Deftones_description: 'School of Rock Seattle',

	SeasonPreviewSpring2023_title: 'Anteprima di stagione primavera 2023',
	SeasonPreviewSpring2023_description: 'School of Rock Seattle',

	Ramones_title: 'I Ramones',
	Ramones_description: 'School of Rock Seattle',

	Soundtrack_title: 'Spettacolo di colonne sonore',
	Soundtrack_description: 'School of Rock Seattle',

	PopPunkVsEmo_title: 'Pop Punk Vs. Emo',
	PopPunkVsEmo_description: 'School of Rock Seattle',

	_90sNostalgia_title: 'Nostalgia anni \'90',
	_90sNostalgia_description: 'School of Rock Seattle',

	TalentShow2022_title: 'Talent Show 2022',
	TalentShow2022_description: 'Seattle Salmon Bay K-8',

	// PRESS PAGE

	b_watch_here: 'Vedi qui',

	king_5_feature_title: 'Servizio Fulcrum / King 5',
	king_5_feature_description: 'Servizio televisivo di Seattle King 5 sponsorizzato da Fulcrum',

	bateristland_title: 'Bateristland Featuring',
	bateristland_description: 'Intervista sul canale YouTube Bateristland',

	komo_news_title: 'Servizio su Komo News',
	komo_news_description: 'Intervista Seattle Refined',

	andrew_rooney_drums_title: 'Reazione di Andrew Rooney',
	andrew_rooney_drums_description: 'Andrew Rooney reagisce all\'esecuzione di Victoria di Tom Sawyer dei Rush',

	upper_lefters_interview_title: 'Intervista Upper Lefters',
	upper_lefters_interview_description: 'Intervista sul canale YouTube Upper Lefters sulla carriera di Victoria e sui suoi piani futuri',

	the_eagle_969_title: '96.9 The Eagle Stazione Radio di Classici',
	the_eagle_969_description: 'Post sul blog di 96.9 The Eagle Classic Hits sulla cover di Rush di Victoria',

	fox_13_news_title: 'Rapporto sulle notizie di Fox 13 Seattle',
	fox_13_news_description: 'Sezione del vero nord-ovest con',

	the_daly_migs_show_interview_title: 'Intervista con The Daly Migs Show',
	the_daly_migs_show_interview_description: 'Intervista sull\'essere invitato a salire sul palco con i Godsmack',

	alizee_defan_07_02_2024_title: 'Intervista con "Alizee Defan"',
	alizee_defan_07_02_2024_description: 'Intervista esclusiva',

	jaime_mendez_news_06_26_2024_title: 'Intervista a "Jaime Mendez News"',
	jaime_mendez_news_06_26_2024_description: 'Notizie locali di Seattle in spagnolo',

	bien_informado_03_22_2023_title: 'Articolo di "Bien Informado"',
	bien_informado_03_22_2023_description: 'Articolo del sito di notizie argentino su Victoria',

	wave_potter_reaction_01_30_2023_title: 'La reazione di Wave Potter',
	wave_potter_reaction_01_30_2023_description: 'Wave Potter reagisce alla copertina di Victoria Lux Æterna dei Metallica',
	
	// ABOUT PAGE

	b_back: 'Torna indietro',

	t_title: 'Victoria Acosta',
	t_pronouns: '(lei)',

	b_read_more: 'Per saperne di più',
	b_read_less: 'Leggi di meno',
	b_stat_age: 'Età',
	b_stat_shows: 'Spettacoli',
	b_stat_yrs: 'Anni di Batteria',
	b_stat_awards: 'Premi',

	t_about: `
Con le bacchette in mano e il ritmo nell’anima, Victoria Acosta, di {age} anni, è una delle giovani batteriste più promettenti del momento. Nata a El Paso, in Texas, cresciuta a Guadalajara, in Messico, e ora residente a Seattle, è conosciuta per dedizione, energia e presenza scenica.

Victoria ha iniziato a suonare la batteria a quattro anni e ha ricevuto la sua prima batteria il 13 settembre 2018. Si è formata alla Musicalerias Academy di Guadalajara e ha proseguito gli studi a Seattle. Dopo una lezione di prova alla School of Rock il 29 maggio 2022, ha saltato Rock 101 ed è entrata direttamente nel Performers Program. Da allora si è esibita in {shows} spettacoli dal vivo.

Ha registrato centinaia di video per i social media e il 13 giugno 2024 è stata invitata dal compositore italiano Alberto Rigonni come batterista ospite per Nemesis Call. Ha ottenuto un endorsement da Soultone Cymbals il 12 settembre 2024 e si è unita al roster di Collision Drumsticks l’8 marzo 2025.

Nell’agosto 2025, Victoria ha partecipato al Drum Fantasy Camp di Los Angeles, studiando con Dave Weckl, Dennis Chambers, Peter Erskine e Gavin Harrison. Nello stesso mese ha iniziato a studiare con l’insegnante Dave Stark, la cui guida continua a sviluppare la sua tecnica, musicalità ed espressività artistica.

Il 13 febbraio 2026 è diventata artista Paiste. Nello stesso mese ha partecipato al Rock and Roll Fantasy Camp, suonato con Nita Strauss, Stewart Copeland, Monte Pittman, Steve Stevens, Skunk Baxter e Leland Sklar, e si è esibita al Viper Room e al Whisky a Go Go. Nel 2026 ha vinto la borsa di studio Neil Peart Drum Set, assegnata dalla Percussive Arts Society e da Hudson.

Oltre alla batteria, Victoria ha iniziato a studiare il violino in quarta elementare ed è entrata nella World Youth Orchestra nel 2024. Ha condiviso il palco con Black Violin al Paramount Theatre e ha debuttato come percussionista con la Ballard Civic Orchestra al Town Hall di Seattle per una celebrazione dell’indipendenza del Messico.

Tra i suoi riconoscimenti figurano il Gold Prize e il Fantastic Technique Award del London Young Musician Contest 2022, oltre all’Annual Star Musician Award e all’Outstanding Drummer Special Award del 2023. Victoria si allena ogni giorno, superando i propri limiti con determinazione e creatività.
	`,

	// PRESS PAGE

	t_footer: 'Tutti i diritti riservati',

	// SOULTONE: 

	b_visit_artist_page: 'Visita la mia pagina artista',

};

export default it;
